import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatDialogActions, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import * as dao from '../shared/dao';

interface DialogData {
	server_url: string;
	order_id: number;
	factureFR: dao.FactureFR;
	isDisabled: boolean;
}

@Component({
  selector: 'lib-pec',
	standalone: true,
  imports: [FormsModule, MatIconModule, MatButtonModule, MatDialogContent, MatDialogActions],
  templateUrl: './pec.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pec.component.scss', '../bs-dialog/bs-dialog.component.scss']
})

export class PecComponent {
	readonly dialogRef = inject(MatDialogRef<PecComponent>);
	readonly dialogdata = inject<DialogData>(MAT_DIALOG_DATA as any);	// 'as any' tricks the compiler

	public pec!: dao.PEC;

	constructor() {	
		this.pec = dao.PEC.createDefault();
	}
	
	ngOnInit() {
		if (this.dialogdata.factureFR.PEC) {
			this.pec = this.dialogdata?.factureFR?.PEC;
			this.pec.montantPECAVentiler = this.pec.montantPECAVentiler/100;			
		}
	}
		
		onClose(save: boolean): void {
			if (save) {
				this.pec.montantPECAVentiler = this.pec.montantPECAVentiler * 100;
				this.dialogRef.close(this.pec);
			} else {
				this.dialogRef.close(undefined);
			}
		}			
}
